<template>
  <div id="app">
    <ValidateDomain v-if="!isValidDomain" />
    <router-view/>
  </div>
</template>


<script>
import ValidateDomain from "@/components/config_components/ValidateDomain/ValidateDomain.vue";

export default {
  props: {
    isValidDomain: {
      type: Boolean,
      required: true,
    },
  },
  components: { ValidateDomain },
  data() {
    return {
      hostname: window.location.hostname,
    };
  }
};
</script>
